module.exports = __webpack_public_path__ + "static/media/home-1.ffd28742.jpg";